import { memo, useMemo } from "react";
import dynamic from "next/dynamic";
import { CardContextProvider } from "@/components/Card/CardContext";
import { usePaletteQuery } from "@/hooks";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import routes from "@/lib/routes";
const PaletteContent = dynamic(() => import("@/components/PaletteContent"));
const MyListPalette = dynamic(() => import("@/components/MyListPalette"));
const GenrePalette = dynamic(() => import("@/components/GenrePalette"));
const EntitledPalette = dynamic(() => import("@/components/EntitledPalette"));
const RankingPalette = dynamic(() => import("@/components/RankingPalette"));
const EntitledHtmlSnippetPalette = dynamic(() =>
  import("@/components/EntitledHtmlSnippetPalette")
);

function Palette({ id, hiddenPrice }) {
  const { data, ...result } = usePaletteQuery({
    variables: { id: id, offset: 0, limit: SLIDER_MAX_NUM },
  });
  const palette = data?.palette;
  const paletteObjects = data?.paletteObjects;

  const items = useMemo(() => {
    if (paletteObjects) {
      const metas = paletteObjects.data.map(
        (data) => data.meta || data.advertising
      );
      return { data: metas, pageInfo: paletteObjects.pageInfo };
    } else {
      return null;
    }
  }, [paletteObjects]);

  const header = {
    text: palette?.header || palette?.name,
  };
  if (palette?.values?.view_type !== "grid") {
    header["link"] = { href: routes.palette(palette?.palette_id) };
  }

  return (
    <CardContextProvider hiddenPrice={hiddenPrice}>
      {palette?.schema === "default" && (
        <PaletteContent
          id={id}
          viewType={palette?.values?.view_type}
          header={header}
          largeCard={palette?.values?.large_card_for_slider}
          items={items}
          {...result}
        />
      )}
      {palette?.schema === "mylist" && <MyListPalette palette={palette} />}
      {palette?.schema === "genre" && <GenrePalette palette={palette} />}
      {palette?.schema === "entitled" && <EntitledPalette palette={palette} />}
      {palette?.schema === "ranking" && <RankingPalette palette={palette} />}
      {palette?.schema === "entitled_html_snippet" && (
        <EntitledHtmlSnippetPalette palette={palette} />
      )}
    </CardContextProvider>
  );
}
export default memo(Palette);
